/**
 * @param marketoForm {MarketoForm}
 * @param select {HTMLSelectElement}
 * @return {void}
 */
module.exports = function copySelectOptionsFromMarketoFormIntoNativeField(marketoForm, select) {
    const marketoOptions = marketoForm.getFormElem()
        .find(`[name=${select.name}]`)
        .find("option");

    select.innerHTML = '';

    for (let option of marketoOptions) {
        const newOption = option.cloneNode(true);
        select.append(newOption);
    }
}